/**
 * Saves a Blob as a file through a temporary link that is clicked and removed. The object URL is
 * revoked at once, or after `keepMs` when the browser may still need it (the invoice PDF keeps it
 * 30 s for slow mobile downloads).
 */
export function downloadBlob(blob: Blob, filename: string, keepMs = 0) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.append(a);
  a.click();
  a.remove();
  if (keepMs > 0) setTimeout(() => URL.revokeObjectURL(url), keepMs);
  else URL.revokeObjectURL(url);
}
